/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const tiptapEditorToolbarButtonStyle = {
  active: {
    backgroundColor: "primary.main",
    color: "common.white",
    "&:hover, &:focus-visible": {
      padding: "0.375rem",
      backgroundColor: "primary.main",
      color: "common.white",
      borderWidth: "0.125rem",
      borderStyle: "solid",
      borderColor: "common.black",
    },
  },
};
